// extracted by mini-css-extract-plugin
export var redoItem = "_ia-1";
export var redoTrigger = "_ia-0";